import type { MessagingChannelsCopy } from './types';

export const KO: MessagingChannelsCopy = {
  title: '메시징',
  description:
    '이미 쓰고 있는 채팅 앱에서 IMAI와 대화하세요. 한 번 연결하면 그 앱에서 IMAI에게 메시지를 보낼 수 있습니다.',
  privacy:
    '연결된 계정에서 온 메시지는 이 워크스페이스에서 본인 이름으로 실행되며 본인의 크레딧을 사용합니다.',
  loading: '메시징 채널 불러오는 중',
  unavailable: '아직 사용할 수 없음',
  unavailableNote: '{channel}은(는) 아직 IMAI용으로 설정되지 않았습니다.',
  connectedBadge: '연결됨',
  cancel: '취소',

  addNumber: '번호 추가',
  countryLabel: '국가 코드',
  countrySearch: '국가 또는 코드 검색…',
  countryEmpty: '국가를 찾을 수 없습니다.',
  numberLabel: '전화번호',
  continueActivation: '계속',
  editNumber: '번호 변경',
  activateQr: '스캔하고 보내기를 누르세요',
  activateHint: '{channel}을(를) 열고 보내기를 누르세요.',
  activationBack: '돌아가기',
  activateButton: '{channel} 열기',
  activateWaiting: '메시지를 기다리는 중입니다. {time} 후 만료됩니다.',
  startAgain: '다시 시작',
  remove: '삭제',
  removeAria: '전화번호 {number} 삭제',
  removeTitle: '{number}을(를) 삭제할까요?',
  removeDescription:
    'IMAI가 iMessage와 WhatsApp에서 이 번호에 더 이상 답하지 않습니다. 언제든 다시 추가할 수 있습니다.',
  removeError: '번호를 삭제하지 못했습니다. 다시 시도하세요.',

  errorInvalidNumber: '지역 번호를 포함한 올바른 전화번호를 입력하세요.',
  errorNumberTaken: '이 번호는 이미 다른 IMAI 계정에서 사용 중입니다.',
  errorRateLimited: '시도 횟수가 너무 많습니다. 잠시 후 다시 시도하세요.',
  errorChannelUnavailable:
    '지금은 이 방법을 사용할 수 없습니다. 다른 방법을 선택하세요.',
  errorSendFailed: '인증을 시작하지 못했습니다. 다시 시도하세요.',
  errorActivationExpired: '활성화가 만료되었습니다. 다시 시작하세요.',

  noteSlack: 'Slack 워크스페이스에서 IMAI에게 메시지를 보내세요.',
  noteTeams: 'Microsoft Teams에서 IMAI에게 메시지를 보내세요.',
  noteTelegram: 'Telegram에서 IMAI 봇과 채팅하세요.',
  connect: '연결',
  connectAria: '{channel} 연결',
  connectError: '{channel} 연결을 시작하지 못했습니다. 다시 시도하세요.',
  connectedOn: '{date}에 연결됨',
  accountFallback: '내 {channel} 계정',
  installSlack: '워크스페이스에 IMAI 추가',
  installTeams: 'Teams에 IMAI 추가',
  openTelegram: 'Telegram에서 열기',
  disconnect: '연결 해제',
  disconnectAria: '{channel}에서 {account} 연결 해제',
  disconnectError: '{channel} 연결을 해제하지 못했습니다. 다시 시도하세요.',
  disconnectTitle: '{channel} 연결을 해제할까요?',
  disconnectDescription:
    '{account}의 메시지가 더 이상 IMAI에 전달되지 않습니다. 언제든 다시 연결할 수 있습니다.',

  toastConnected: '{channel} 연결됨',
  toastConnectedGeneric: '계정이 연결되었습니다',
  toastErrorExpired: '로그인이 너무 오래 걸렸습니다. 다시 연결해 보세요.',
  toastErrorInvalidState:
    '이 로그인 링크는 더 이상 유효하지 않습니다. 다시 시도하세요.',
  toastErrorAccountTaken:
    '이 계정은 이미 다른 IMAI 사용자와 연결되어 있습니다.',
  toastErrorNotMember: '더 이상 이 워크스페이스의 멤버가 아닙니다.',
  toastErrorProvider: '로그인이 완료되지 않았습니다. 다시 연결해 보세요.',
  toastErrorGeneric: '계정을 연결하지 못했습니다. 다시 시도하세요.',
};
